import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Tooltip from 'shared/components/Tooltip';
import styles from './JobAttribute.module.scss';

const JobAttribute = ({ iconClassName, title, children, approved, noLeftSpace }) => {
  const { t } = useTranslation('common');
  const attribute = (
    <div className={styles.jobAttribute}>
      <div className={cn(styles.icon, { [styles.notApproved]: !approved, [styles.noLeftSpace]: noLeftSpace })}>
        <i className={iconClassName} />
      </div>
      <div className={cn(styles.content, { [styles.notApproved]: !approved })}>
        <h4>{title}</h4>
        <span>{children}</span>
      </div>
    </div>
  );

  if (!approved) {
    return (<Tooltip content={t('tooltip.awaitingApproval')}>{attribute}</Tooltip>);
  }

  return attribute;
};

JobAttribute.propTypes = {
  iconClassName: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  approved: PropTypes.bool,
  noLeftSpace: PropTypes.bool,
};

JobAttribute.defaultProps = {
  iconClassName: '',
  title: '',
  children: null,
  approved: true,
  noLeftSpace: false,
};

export default JobAttribute;
